export default __webpack_public_path__ + "static/media/ottoman-1-seat.6dca07d8.webp";